// extracted by mini-css-extract-plugin
var _1 = "tSOrGhLhhG8fISmMuGLA";
export { _1 as "container" }
